// extracted by mini-css-extract-plugin
module.exports = {"base":"index-base-1jMzH","play":"index-play-1sosb","animal":"index-animal-1odYS","mute":"index-mute-2i91O"};